import { queryOptions, QueryClient } from '@tanstack/react-query';
import { scadaKeys } from './queryKeys';
import { ScadaConfigurationPathConstants } from '../../../assetConfiguration/assetConstants/pathConstants';
import axiosInstance from '../../../../../constants/axiosInstance';

export const graphLayoutQueryOptions = (assetId: string) =>
    queryOptions({
        queryKey: scadaKeys.graph(assetId),
        queryFn: async () => {
            const { data } = await axiosInstance().post(
                ScadaConfigurationPathConstants.GET_ASSET_GRAPHS,
                { id: assetId }
            );
            const results = data?.results;
            return {
                graphLayout: results?.layout,
                assetId: results?.nodeId || assetId,
            };
        },
        staleTime: 5 * 60 * 1000,
        enabled: !!assetId,
    });

export const entityDetailsQueryOptions = (entityId: string) =>
    queryOptions({
        queryKey: scadaKeys.entity(entityId),
        queryFn: async () => {
            const { data } = await axiosInstance().post(
                ScadaConfigurationPathConstants.GET_ENTITY_DETAILS,
                { id: entityId }
            );
            return data?.result;
        },
        staleTime: 5 * 60 * 1000,
        enabled: !!entityId,
    });

export const historicalDataQueryOptions = (assetId: string, timestamp: number) =>
    queryOptions({
        queryKey: scadaKeys.historicalData(assetId, timestamp),
        queryFn: async () => {
            const { data } = await axiosInstance().post(
                ScadaConfigurationPathConstants.REAL_TIME_SCADA,
                { id: assetId, time: timestamp }
            );
            return data?.data;
        },
        enabled: !!assetId && !!timestamp,
        staleTime: Infinity,
        gcTime: 30 * 60 * 1000,
    });

export const updateSSECache = (
    queryClient: QueryClient,
    assetId: string,
    layoutData: Record<string, unknown>,
    timestamp: number
) => {
    queryClient.setQueryData(scadaKeys.sseLive(assetId), {
        layoutData,
        timestamp,
        lastUpdated: Date.now(),
    });
};

export const invalidateSSEData = (queryClient: QueryClient, assetId: string) => {
    queryClient.invalidateQueries({ queryKey: scadaKeys.sseLive(assetId) });
};

export const prefetchGraphDetails = (queryClient: QueryClient, assetId: string) => {
    return queryClient.prefetchQuery(graphLayoutQueryOptions(assetId));
};
